<template>
  <div class="app-wrapper" ref="appWrapper">
    <div class="main">
      <nav-bar ref="navBar" />
      <div class="app-container">
        <app-main />
      </div>
      <footer-bar />
    </div>
  </div>
</template>

<script>
import { NavBar, AppMain, FooterBar } from '@/views/layout/components'
import { isWX } from '@/utils/helper'

export default {
  name: 'Layout',
  components: {
    NavBar,
    AppMain,
    FooterBar
  },
  watch: {
  },
  computed: {
  },
  data () {
    return {
      showTop: false,
      inWX: false
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.scrollToTop)
    this.inWX = isWX()
  },
  updated: function () {
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    scrollToTop () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const browserHeight = window.outerHeight
      if (browserHeight < scrollTop) {
        this.showTop = true
      } else {
        this.showTop = false
      }
    },
    toTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
  @import "../../styles/variables";
  .app-wrapper {
    .app-container {
      position: relative;
      padding-top: 0px;
      margin-bottom: 70px;
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue